module.exports = __webpack_public_path__ + "static/media/BackingRectangle3.0f9abacd.jpg";